<template>
  <div>
    <Chart
      :categories="chart.xTag"
      :series="chart.series"
      :yAxis="chart.yAxis"
      :legend="chart.legend"
      :height="height">
    </Chart>
  </div>

</template>

<script>
  import Chart from '@/expertoRetail/components/charts/Highcharts'
  import { chartMetricOptions, chartMetricSeriesName } from '@/expertoRetail/atoms/AccumulatedSales/Common/baseParameters'
  export default {
    name: 'ColumnLineChart',
    props: {
      selectedDim: {
        required: false,
        default: 'retail_id'
      },
      height: {
        default: 300
      },
      sellOutChartData: {
        type: Object,
        required: true
      },
    },
    components: {
      Chart
    },
    data () {
      return {
        style: '',
        loading: false,
        chart: {
          xTag: [],
          series: [],
          availableHeight: null,
          yAxis: []
        }
      }
    },
    created () {
      this.loadData()
      this.$eventHub.$on('filter-pane-filter-update', this.loadData)
      this.$eventHub.$on('sellout-dashboard-metric-option-changed', this.loadData)
      this.style = 'overflow: auto; height: ' + String(this.vuexAvailableHeight - 10) + 'px'
    },
    beforeDestroy () {
      this.$eventHub.$off('sellout-dashboard-metric-option-changed', () => {})
    },
    watch: {
      vuexAvailableHeight () {
        this.style = 'overflow: auto; height: ' + String(this.vuexAvailableHeight - 10) + 'px'
      },
      salesAnalysisFilters: {
        deep: true,
        handler (newFilter) {
          this.loadData()
        }
      },
      sellOutChartData () {
        this.loadData()
      }
    },
    computed: {
      appMetric () {
        return this.$store.state.metric
      },
      salesAnalysisFilters () {
        return this.$store.state.salesAnalysis.filters
      },
      selloutDimension () {
        return this.$store.state.accumulatedSales.selectedDimension.card1
      },
      vuexAvailableHeight () {
        return Math.round(this.$store.state.appAvailableHeight - 450)
      }
    },
    methods: {
      chartCatDim () {
        if (this.selloutDimension.store_dimensions.length > 0) {
          return this.selloutDimension.store_dimensions[0]
        } else if (this.selloutDimension.product_dimensions.length > 0) {
          return this.selloutDimension.product_dimensions[0]
        }
      },
      loadData () {
        this.loading = true
        let series = []
        this.chart.yAxis = [
          { // Primary yAxis
            labels: {
              style: {
                color: 'navy'
              }
            },
            title: {
              text: 'Ventas',
              style: {
                color: 'navy'
              }
            }
          }, { // Secondary yAxis
            title: {
              text: 'Stock',
              style: {
                color: '#F7A35C'
              }
            },
            labels: {
              style: {
                color: '#F7A35C'
              }
            },
            opposite: true
          }
        ]
        let metric1 = chartMetricOptions[this.appMetric][0]
        let metric2 = chartMetricOptions[this.appMetric][1]
        let metric3 = chartMetricOptions[this.appMetric][2]
        let cat = this.sellOutChartData.data.map(x => x[this.chartCatDim()])
        let data1 = this.sellOutChartData.data.map(x => x[metric1])
        let data2 = this.sellOutChartData.data.map(x => x[metric2])
        let data3 = this.sellOutChartData.data.map(x => x[metric3])
        this.chart.series = series
        
        series.push(
          {
            name: chartMetricSeriesName[this.appMetric][1],
            data: data2,
            type: 'column',
            color: '#90ED7D',
            yAxis: 0
          },
          {
            name: chartMetricSeriesName[this.appMetric][0],
            data: data1,
            type: 'column',
            yAxis: 0
          },
          {
            name: chartMetricSeriesName[this.appMetric][2],
            data: data3,
            color: '#F7A35C',
            yAxis: 1

          }
        )
        this.chart.xTag = cat
        this.loading = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/expertoRetail/atoms/AccumulatedSales/CardComponents/ColumnLineChart/ColumnLineChart.vue